import { get } from 'lodash-es'

import { Store } from '..'

export const getShiftBookingsEntityMap = (state: Store) => {
  return get(state, 'shiftBookings.entityMap', {})
}
